<template>
  <div style="height: 100%;overflow: hidden">
    <div class="nothing-data" v-if="ServiceTypeCount.length === 0"></div>
    <div v-else style="height: 100%;width: 100%;margin: auto 0" id="bar" ref="wrap"></div>
  </div>
</template>

<script>
export default {
  name: 'indexServiceType',
  data () {
    return {
      ServiceTypeCount: [],
      xData: [],
      yData: []
    }
  },
  created () {
    // 服务次数
  },
  methods: {
    getChartsData (arr) {
      this.ServiceTypeCount = arr
      this.xData = []
      this.yData = []
      for (let i = 0; i < arr.length; i++) {
        this.xData.push(arr[i].servicetype)
        this.yData.push(arr[i].servicecount)
      }
      let vm = this
      setTimeout(() => {
        vm.getChartData()
      }, 300)
    },
    getChartData () {
      if (this.ServiceTypeCount.length === 0) {
        return
      }
      let chart = this.$echarts.init(this.$refs.wrap)
      chart.setOption({
        color: ['#3398DB'],
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          top: '3%',
          left: '4%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: this.xData,
            axisTick: {
              alignWithLabel: true
            },
            axisLine: {
              lineStyle: {
                color: '#7fd4ff',
                width: 1
              }
            },
            axisPointer: {
              type: 'shadow'
            },
            axisLabel: { // X轴文字倾斜
              interval: 0,
              rotate: 20
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLine: {
              lineStyle: {
                color: '#7fd4ff',
                width: 1 // 这里是为了突出显示加上的
              }
            },
            name: '',
            min: 0,
            // max: 250,
            // interval: 50,
            axisLabel: {
              formatter: '{value}'
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#182f4d',
                width: 1 // 这里是为了突出显示加上的
              }
            }
          }
        ],
        series: [
          {
            name: '数量',
            type: 'bar',
            barWidth: '60%',
            data: this.yData
          }
        ]
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/monitoring/bigComponents/indexServiceType.vue